import { render, staticRenderFns } from "./ProjectAgentDetails.vue?vue&type=template&id=07c4e086&"
import script from "./ProjectAgentDetails.vue?vue&type=script&lang=js&"
export * from "./ProjectAgentDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports